import type { ResponseType } from '@/types/common';
import type {
  IssueField,
  IssueFieldLabel,
  IssueFieldOption,
  IssueFieldPriority,
  IssueFieldSeverity,
  IssueFieldStatus,
  IssueType,
} from '@/types/issue';
import httpUtil from '@/utils/http';
export * from './project';

const request = httpUtil.accurate.request;
const prefix = 'v1/issues';

export const issueFieldApi = {
  /**
   * @description 获取所有字段配置
   */
  getAll(): ResponseType<IssueField[]> {
    return request({
      url: prefix + '/allFields',
      method: 'GET',
    });
  },

  /**
   * @description 创建自定义字段配置
   */
  create(data: IssueField): ResponseType<IssueField> {
    return request({
      url: prefix + '/customField',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 更新自定义字段配置
   */
  update(id: number, data: IssueField): ResponseType<IssueField> {
    return request({
      url: prefix + '/customField/' + id,
      method: 'PUT',
      data,
    });
  },

  /**
   * @description 删除自定义字段配置
   */
  del(id: number): ResponseType<IssueField> {
    return request({
      url: prefix + '/customField/' + id,
      method: 'DELETE',
    });
  },

  /**
   * @description 获取选项值结果
   */
  getOptions(
    fieldId: number,
    params?: {
      parentOptionId?: number;
      optionTree?: boolean;
    },
  ): ResponseType<IssueFieldOption[]> {
    return request({
      url: prefix + '/customField/' + fieldId + '/options',
      method: 'GET',
      params: params,
    });
  },

  /**
   * @description 创建选项值
   */
  createOption(fieldId: number, data: any): ResponseType<IssueFieldOption> {
    return request({
      url: prefix + '/customField/' + fieldId + '/option',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 更新选项值
   */
  updateOption(fieldId: number, optionId: number, data: any): ResponseType {
    return request({
      url: prefix + '/customField/' + fieldId + '/option/' + optionId,
      method: 'PUT',
      data,
    });
  },

  /**
   * @description 删除选项值
   */
  delOption(fieldId: number, optionId: number): ResponseType {
    return request({
      url: prefix + '/customField/' + fieldId + '/option/' + optionId,
      method: 'DELETE',
    });
  },

  /**
   * @description 移动选项值
   */
  moveOption(fieldId: number, data: { moveId: number; targetId: number; isBottom: boolean }): ResponseType {
    return request({
      url: prefix + '/customField/' + fieldId + '/option/move',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 获取问题类型选项值
   */
  getIssueTypeOptions(): ResponseType<IssueType[]> {
    return request({
      url: prefix + '/issueType',
      method: 'GET',
    });
  },

  /**
   * @description 获取问题状态选项值
   */
  getIssueStatusOptions(): ResponseType<IssueFieldStatus[]> {
    return request({
      url: prefix + '/issueStatus',
      method: 'GET',
    });
  },

  /**
   * @description 获取问题优先级选项值
   */
  getPriorityOptions(): ResponseType<IssueFieldPriority[]> {
    return request({
      url: prefix + '/issuePriority',
      method: 'GET',
    });
  },

  /**
   * @description 获取问题标签选项值
   */
  getIssueLabelOptions(params?: { fieldId?: number; search?: string }): ResponseType<IssueFieldLabel[]> {
    return request({
      url: prefix + '/labels',
      method: 'GET',
      params,
    });
  },

  /**
   * @description 获取问题严重程度值
   */
  getIssueSeverityOptions(): ResponseType<IssueFieldSeverity[]> {
    return request({
      url: prefix + '/issueSeverity',
      method: 'GET',
    });
  },
};
